export const DEFAULT_SKIN_SELECTION =
  Object.freeze({
    version: 1,
    ball: "ball_default",
    paddle: "paddle_default"
  });


const VALID_SKINS = Object.freeze({
  ball: new Set([
    "ball_default",
    "ball_star",
    "ball_football",
    "ball_flower",
    "ball_planet",
    "ball_rainbow",
    "ball_diamond"
  ]),

  paddle: new Set([
    "paddle_default",
    "paddle_stool",
    "paddle_grass",
    "paddle_rainbow",
    "paddle_carpet",
    "paddle_wave",
    "paddle_mecha"
  ])
});


export function normalizeSkinSelection(
  value
) {
  const source =
    value
    && typeof value === "object"
      ? value
      : {};

  return {
    version: 1,

    ball: VALID_SKINS.ball.has(
      source.ball
    )
      ? source.ball
      : DEFAULT_SKIN_SELECTION.ball,

    paddle: VALID_SKINS.paddle.has(
      source.paddle
    )
      ? source.paddle
      : DEFAULT_SKIN_SELECTION.paddle
  };
}


let runtimeSelection =
  normalizeSkinSelection(null);


export async function loadSkinSelection() {
  return {
    ...runtimeSelection
  };
}


export async function saveSkinSelection(
  selection
) {
  runtimeSelection =
    normalizeSkinSelection(
      selection
    );

  return {
    ...runtimeSelection
  };
}
